import axios from "../api/axios";

export const payAnnonce = async ( paymentIntent: string ) => {
  try {

    const response = await axios.put(`/annonce/pay-annonce`, { paymentIntent })
    console.log('Réponse du serveur après création de l\'annonce :', response.data);

    return response.data;

  } catch (error: any) {
    console.error('Erreur lors de la création:', error.response?.data);
    throw new Error(error.response?.data?.error || "Erreur de création");
  }
};